document.addEventListener('DOMContentLoaded', function() {
    var slider = tns({
        container: '.collection_slider',
        slideBy: 1,
        edgePadding: 0,
        center: false,
        controls: true,
        controlsContainer: '.slider-controls',
        nav: false,
        autoplay: true,
        autoplayTimeout: 3500,
        autoplayButton: false,
        autoplayButtonOutput: false,
        loop: true,
        gutter: 36,
        rewind: false,
        autoplayHoverPause: true,
        responsive: {
            1490: {
                items: 3,
                fixedWidth: false
            },
            1440: {
                items: 2.8,
                fixedWidth: false
            },
            1025: {
                items: 2,
                fixedWidth: false
            },
            860: {
                items: 4,
                fixedWidth: false
            },
            780: {
                items: 3,
                fixedWidth: false
            },
            481: {
                items: 2,
                fixedWidth: false
            },
            0: {
                items: 1,
                fixedWidth: false
            }
        }
    });

    var info = slider.getInfo();
    var slideCount = info.slideCount;
    var navContainer = document.createElement('div');
    navContainer.className = 'tns-nav custom-nav';
    
    for (var i = 0; i < slideCount; i++) {
        var button = document.createElement('button');
        button.setAttribute('data-nav', i);
        button.setAttribute('aria-label', 'Slide ' + (i + 1));
        if (i === 0) button.classList.add('tns-nav-active');
        navContainer.appendChild(button);
    }
    
    var dotsContainer = document.querySelector('.slider-dots-container');
    dotsContainer.appendChild(navContainer);
    
    slider.events.on('indexChanged', function(info) {
        var buttons = navContainer.querySelectorAll('button');
        buttons.forEach(function(btn) {
            btn.classList.remove('tns-nav-active');
        });
        
        var displayIndex = info.displayIndex;
        var realIndex = (displayIndex - 1) % slideCount;
        
        if (buttons[realIndex]) {
            buttons[realIndex].classList.add('tns-nav-active');
        }
    });
    
    navContainer.addEventListener('click', function(e) {
        if (e.target.tagName === 'BUTTON') {
            var index = parseInt(e.target.getAttribute('data-nav'));
            slider.goTo(index);
        }
    });
});